import type { ComposeFormStore } from 'owa-calendar-compose-types';
import { getComposeStoreManager } from '../store/store';
import { getLegacyComposeStore } from '../store/legacyStore';
import { isFeatureEnabled } from 'owa-feature-flags';

export function getComposeStore(formId?: string | null): ComposeFormStore {
    let store;

    if (isFeatureEnabled('cal-multiple-compose-forms') && !!formId) {
        store = getComposeStoreManager().storeMap.get(formId);
    } else {
        store = getLegacyComposeStore();
    }

    if (!store) {
        throw new Error('Compose store missing for id: ' + formId);
    }

    return store;
}
